import { connect } from "react-redux";
import styles from "./SessionDetails.module.css";
import alert from "../../../components/AlertModal/alertModal";
import {
  closeLoading,
  openLoading,
} from "../../../components/loadingModal/loading";
import { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getSession } from "../../../actions/reportsActions";
import ArrowGoBack from "../../../components/ArrowGoBack/ArrowGoBack";

const SessionDetails = ({ getSession }) => {
  const [html, setHtml] = useState("");
  const { idSession, ...params } = useParams();
  const navigate = useNavigate();

  const getInitialData = useCallback(async () => {
    openLoading();
    try {
      const response = await getSession(idSession);
      setHtml(response.data.html);
    } catch (error) {
      alert(
        "ERROR",
        error?.message || "Error al cargar los detalles de la sesión",
      );
    } finally {
      closeLoading();
    }
  }, [getSession, idSession]);

  useEffect(() => {
    getInitialData();
  }, [getInitialData]);

  const handleClose = () => {
    navigate(-1, { params: params });
  };

  return (
    <div className="box-container">
      <ArrowGoBack max={2} />
      <div className={`box-entry ${styles.container}`}>
        <button
          alt="Close Details Page"
          className={styles.closeButton + " close"}
          onClick={handleClose}
        />
        <div
          dangerouslySetInnerHTML={{ __html: html }}
          className={styles.htmlCon}
        />
      </div>
    </div>
  );
};

export default connect(null, { getSession })(SessionDetails);
